export default __webpack_public_path__ + "static/media/9.796e5f46.jpg";